module.exports = __webpack_public_path__ + "svg/aoo.36d266d.svg";